import { createContext } from 'use-context-selector';

export enum SearchType {
  Patients = 'patients',
  // Visits = 'visits',
  // Documents = 'documents',
  // Tasks = 'tasks',
}

export interface MergePair {
  firstPatientId: number;
  secondPatientId: number;
}

export interface MergeContextInterface {
  isSelectable: boolean;
  isMergeEnabled: boolean;
  setMergeEnabled: (value: boolean) => void;
  setMergePair: (value: MergePair | null) => void;
}

export const defaultMergeContextValues: MergeContextInterface = {
  isSelectable: false,
  isMergeEnabled: false,
  setMergeEnabled: () => undefined,
  setMergePair: () => undefined,
};

export const MergeContext = createContext(defaultMergeContextValues);
